import { trackEvent } from '@Services/analytics/tracking.service.ts';

export const useBusinessAddressAnalytics = () => {
  function reportActOnBusinessAddressScreen(isBusinessAddressTheSame: boolean): void {
    trackEvent('Act on Business Address Screen', {
      'Is Business Address the Same': isBusinessAddressTheSame,
    });
  }

  return { reportActOnBusinessAddressScreen };
};
